import styled from 'styled-components';
import { UseFormRegisterReturn, RegisterOptions } from 'react-hook-form';
import { GenericInputError } from './GenericInputError';
import { Tooltip } from './Tooltip';
import { Icon } from './Icon';
import { HStack, VStack } from '@bpba/ui-components';
import { NumberFormat } from './NumberFormat';
import { GenericInputProps } from './GenericInputProps';
import { IndexValue } from '../../../types/IndexValue';
import { StyledSpan } from '../StyledSpan';

export function getValidations<T extends IndexValue>(props: GenericInputProps<T>): UseFormRegisterReturn {
  const registerOptions: RegisterOptions<T> = {
    required: { value: props.required, message: 'Requerido para avanzar' },
  };

  const charactersTypeName = props.charactersType ? props.charactersType : 'caracteres';
  if (props.maxLength !== undefined)
    registerOptions.maxLength = {
      value: props.maxLength,
      message: 'Debe tener hasta ' + props.maxLength + ' ' + charactersTypeName,
    };

  if (props.minLength !== undefined)
    registerOptions.minLength = {
      value: props.minLength,
      message: 'Debe tener al menos ' + props.minLength + ' ' + charactersTypeName,
    };

  if (props.max !== undefined)
    registerOptions.max = {
      value: props.max,
      message: 'El valor máximo es ' + NumberFormat.formatNumber(props.max),
    };

  if (props.min !== undefined)
    registerOptions.min = {
      value: props.min,
      message: 'El valor mínimo es ' + NumberFormat.formatNumber(props.min),
    };

  if (props.pattern !== undefined)
    registerOptions.pattern = {
      value: props.pattern,
      message: 'Formato inválido',
    };

  if (props.validateFunction !== undefined) registerOptions.validate = props.validateFunction;

  if (props.onChange !== undefined) registerOptions.onChange = props.onChange;

  if (props.isNumber !== undefined) registerOptions.valueAsNumber = props.isNumber;

  if (props.valueParser !== undefined) registerOptions.setValueAs = props.valueParser;

  return props.formRegister(props.name, registerOptions);
}

export function GenericInput<T extends IndexValue>(props: GenericInputProps<T>) {
  const validations: UseFormRegisterReturn = getValidations(props);

  return (
    <VStack mt={'20px'}>
      <StyledLine alignItems={'center'}>
        {props.children}
        <input
          type={props.type}
          disabled={props.disabled}
          placeholder={props.placeholder}
          {...validations}
          onBeforeInput={props.onBeforeInput}
          autoComplete={props.autocomplete == null || props.autocomplete ? 'on' : 'off'}
        />
        {props.tooltip && <Tooltip message={props.tooltip} />}
        {props.icon && <Icon iconComponent={props.icon} />}
      </StyledLine>
      {props.label && (
        <StyledSpan my={'4px'} fontWeight={600} fontSize={'12px'} color="primary.1">
          {props.label}
        </StyledSpan>
      )}
      <GenericInputError name={props.name} errorCollection={props.errorCollection} />
    </VStack>
  );
}

const StyledLine = styled(HStack)({
  [`*`]: {
    width: '100%',
  },
});
